import React, { useState } from 'react';
import Chat from './chat';
import '../assets/css/screen.css';
import male from '../assets/img/male.jpeg'; 
import female from '../assets/img/female.jpeg'; 
import call from '../assets/img/call.png'; 
import vcall from '../assets/img/videocall.png'; 
import ellipsis from '../assets/img/ellipsis.png'; 
import emoji from '../assets/img/emoji.png'; 
import pin from '../assets/img/pin.png'; 
import camara from '../assets/img/camara.png'; 
import voice from '../assets/img/voice.png'; 
import send from '../assets/img/send.png'; 

export default function Screen() {
    const [messages, setMessages] = useState([]);

    const [focus, setFocus] = useState('Receiver');
    const [view, setView] = useState(true);

    const [srcvoiceshow, setsrcVoiceshow] = useState(true);
    const [srcsendshow, setsrcSendshow] = useState(false);
    const [srccamarashow, setsrcCamarashow] = useState(true);
    const [srcmessage, setsrcMessage] = useState('');
    const [srcmsgsend, setsrcMessagesend] = useState(false);
    const [srcstatus, setSrcstatus] = useState('Online');

    const [desvoiceshow, setdesVoiceshow] = useState(true);
    const [dessendshow, setdesSendshow] = useState(false);
    const [descamarashow, setdesCamarashow] = useState(true);
    const [desmessage, setdesMessage] = useState('');
    const [desmsgsend, setdesMessagesend] = useState(false);
    const [desstatus, setDesstatus] = useState('Online');

    const handleview = () => {
        setView(!view);
        setFocus(focus==='Sender' ? 'Receiver' : 'Sender');
    }
    const getCurrentTime = () => {
        const date = new Date();
        let hours = date.getHours();
        let minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours %= 12;
        hours = hours || 12; // 12 AM/PM should be 12, not 0
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${hours}:${minutes}${ampm}`;
    }

    const srchandlevoicesend = (event) => {
        setsrcMessage(event.target.value);
        if(event.target.value.trim()===""){
            setsrcVoiceshow(true);
            setsrcSendshow(false);
            setsrcCamarashow(true);
            setDesstatus('Online');
        }else{
            setsrcVoiceshow(false);
            setsrcSendshow(true);
            setsrcCamarashow(false)
            setDesstatus('Typing...');
        }
    }
    const srchandleSend = () => {
        const currentTime = getCurrentTime();
        setsrcMessagesend(!srcmsgsend);
        setMessages([...messages, { from: "src", message: srcmessage, time: currentTime }]);
        setsrcMessage('');
        setsrcVoiceshow(true);
        setsrcSendshow(false);
        setsrcCamarashow(true);
        setDesstatus('Online');
    }

    const deshandlevoicesend = (event) => {
        setdesMessage(event.target.value);
        if(event.target.value.trim()===""){
            setdesVoiceshow(true);
            setdesSendshow(false);
            setdesCamarashow(true);
            setSrcstatus('Online');
        }else{
            setdesVoiceshow(false);
            setdesSendshow(true);
            setdesCamarashow(false)
            setSrcstatus('Typing...');
        }
    }
    const deshandleSend = () => {
        const currentTime = getCurrentTime();
        setdesMessagesend(!desmsgsend);
        setMessages([...messages, { from: "des", message: desmessage, time: currentTime }]);
        setdesMessage('');
        setdesVoiceshow(true);
        setdesSendshow(false);
        setdesCamarashow(true);
        setSrcstatus('Online');
    }

  return (
    <>
      <div className="main">
        <div className="scr">
            <div className={`src msg-box ${view ? '' : 'hidden'}`}>
                <div className="heading">
                    <img className="icon" src={male} alt="Male" />
                    <div className="user">
                        <p className="author">Sender</p>
                        <p className="status">{srcstatus}</p>
                    </div>
                    <img className='vcall' src={vcall} alt="Video Call" />
                    <img className='call' src={call} alt="Call" />
                    <img className='ellipsis' src={ellipsis} alt="Ellipsis" />
                </div>
                <div className="textview">
                    <Chat chatmsg={messages} myview={'Sender'} />
                </div>
                <div className="textboxview">
                    <div className="textbox">
                        <img className='emoji' src={emoji} alt="Emoji" />
                        <textarea className='txt' onChange={srchandlevoicesend} value={srcmessage} placeholder='Message' rows="2" wrap="hard"></textarea>
                        <img className='pin' src={pin} alt="Pin" />
                        {srccamarashow && <img className='camara' src={camara} alt="Camara" /> }
                    </div>
                    <div className="voicemsg">
                    {srcvoiceshow && <img className='voice' src={voice} alt="Voice" /> }
                    {srcsendshow && <img className='send' onClick={srchandleSend} src={send} alt="Send" /> }
                    </div>
                </div>
            </div>
            <div className={`des msg-box ${view ? 'hidden' : ''}`}>
                <div className="heading">
                    <img className="icon" src={female} alt="Female" />
                    <div className="user">
                        <p className="author">Receiver</p>
                        <p className="status">{desstatus}</p>
                    </div>
                    <img className='vcall' src={vcall} alt="Video Call" />
                    <img className='call' src={call} alt="Call" />
                    <img className='ellipsis' src={ellipsis} alt="Ellipsis" />
                </div>
                <div className="textview">
                    <Chat chatmsg={messages} myview={'Receiver'} />
                </div>
                <div className="textboxview">
                    <div className="textbox">
                        <img className='emoji' src={emoji} alt="Emoji" />
                        <textarea className='txt' onChange={deshandlevoicesend} value={desmessage} placeholder='Message' rows="2" wrap="hard"></textarea>
                        <img className='pin' src={pin} alt="Pin" />
                        {descamarashow && <img className='camara' src={camara} alt="Camara" /> }
                    </div>
                    <div className="voicemsg">
                        {desvoiceshow && <img className='voice' src={voice} alt="Voice" /> }
                        {dessendshow && <img className='send' onClick={deshandleSend} src={send} alt="Send" /> }
                    </div>
                </div>
            </div>
            <button onClick={handleview}>{focus}</button>
        </div>
      </div>
    </>
  )
}
